he.countingNumbers = function (elements) {
    if (0 === elements.length) {
        return;
    }

    // animate all elements, but filter for already animated items first
    $(elements).filter(':not(.animated)').each(function () {
        $(this).prop('Counter', 0).animate(
            {
                Counter: $(this).text()
            },
            {
                duration: 3000,
                easing: 'swing',
                step: function (now) {
                    $(this).text(Math.ceil(now));
                },
                complete: function () {
                    $(this).addClass('animated');
                },
                queue: false,
            }
        );
    });
};